import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";


@Form({title: "adf"})
export class Config {
	@Input({type: InputType.CHECKBOX, title: "Show Organizations"})
	public showOrganizations: boolean;
}



// WEBPACK FOOTER //
// ./src/panels/userProfile/Config.ts